module.exports = __webpack_public_path__ + "assets/retina_Segment6Detailed.3a109e3db1cf8d0f6473eb956a14fb1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Segment6Detailed.png
// module id = 712
// module chunks = 0